import React from 'react'
/*Images-Icons*/
import argentina from "../assets/iconos/AR.png"
import china from "../assets/iconos/CH.png"
import colombia from "../assets/iconos/CO.png"
import us from "../assets/iconos/US.png"
import india from "../assets/iconos/IN.png"
/*Styles*/
import '../styles/Nosotros/OfficesAbout.css'

import { useTranslation } from 'react-i18next'

function OfficesAbout() {
    const {t} = useTranslation();

  return (
    <section className="aboutOffice">
        <div className='flag-container nuestras-oficinas'>
            <h2 className='nuestras-oficinas' style={{fontFamily:'Outfit, sans-serif', fontWeight:'700', color: '#017C79', margin: '0px'}}>{t("our")} <br/> {t("offices")}</h2>
        </div>
        <div className='flag-container'>
            <div className='flag-container-img'>
                <img src={colombia} alt="colombia" className='flag'/>
            </div>
            <div className='flag-container-txt'>
                <h4>Colombia</h4>
                <p>{t("office_1")}</p>
            </div>
        </div>
        <div className='flag-container'>
            <div className='flag-container-img'>
                <img src={argentina} alt="argentina" className='flag'/>
            </div>
            <div className='flag-container-txt'>
                <h4>Argentina</h4>
                <p>{t("office_2")}</p>
            </div>
        </div>
        <div className='flag-container'>
            <div className='flag-container-img'>
                <img src={us} alt="US" className='flag'/>
            </div>
            <div className='flag-container-txt'>
                <h4>{t("USA")}</h4>
                <p>{t("office_3")}</p>
            </div>
        </div>
        <div className='flag-container'>
            <div className='flag-container-img'>
                <img src={china} alt="china" className='flag'/>
            </div>
            <div className='flag-container-txt'>
                <h4>China</h4>
                <p>{t("office_4")}</p>
            </div>
        </div>
        <div className='flag-container'>
            <div className='flag-container-img'>
                <img src={india} alt="india" className='flag'/>
            </div>
            <div className='flag-container-txt'>
                <h4>India</h4>
                <p>{t("office_5")}</p>
        </div>
        </div>
    </section>
  )
}

export default OfficesAbout